<template>
  <div class="cover-test d-flex align-items-center justify-content-center mt-3 mt-md-0">
    <div class="bg-white shadow-sm p-4 p-md-5">

      <LoaderContent v-if="isLoading" :welcomeMessage="false" :alignSpinnerTop="true" />
      
      <div class="col-12 d-flex align-items-center">
        <img class="icon-file" src="@/assets/images/test.svg" alt="icon-file" />
        <div>
          <h5 class="text-secondary">{{ cover.name }}</h5>
          <em class="title-opportunity">{{ opportunity() }}</em>
        </div>
      </div>

      <hr class="mb-4" />

      <div v-html="this.cover.description"></div>

      <div class="box-test">
        <p class="total">
          Você responderá a
          <span>{{ this.cover.qtd_of_questions }} questões</span>
        </p>
      </div>

      <router-link :to="`/vagas/${ this.$route.params.id }/inscricao/${ this.header_test.id }/teste/${ this.first_question }`" class="btn btn-blue-ml btn-lg d-flex align-items-center justify-content-between btn-start mt-4">
        Começar
        <chevron-right-icon class="h3 ml-5 mb-0" />
      </router-link>

    </div>
  </div>
</template>

<script>
import LoaderContent from '@/components/loader/LoaderContent.vue'
import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";

export default {
  name: "CoverTest",

  data() {
    return {
      cover: [],
      header_test: [],
      first_question: '',
      isLoading: false
    };
  },

  head(){
    return this.$head({
      title: "",
    });
  },

  mounted() {
    this.isLoading = true
    this.$store.dispatch("tests/testCover", { opportunityId: this.opportunityId, testId : this.$route.params['testId']}).then(cover => {
      const first_question = cover.testCover.json.header_test.links.first_question

      this.cover = cover.testCover.json.header_test.test
      this.header_test = cover.testCover.json.header_test
      this.first_question = first_question.match(/\d+/g, ' ')[3]
      this.$store.commit('tests/SET_TEST_NAVIGATION_CONTROL', {
        can_edit: this.cover.can_edit,
        test_id: this.cover.id,
        cover_url: this.$route.path
      })
      this.isLoading = false
    })
  },

  components: {
    LoaderContent,
    ChevronRightIcon
  },

  computed: {
    opportunityId() {
      const id = this.$route.params.id.match(/\d+/)[0];
      return id;
    }
  },

  methods: {
    opportunity(){
      let title = this.$route.params.id.replace(/\d+/, '')
      return title.replace(/-(?!>)/g, ' ')
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.tabs {
  .btn {
    white-space: normal;
  }
}

.cover-test {
  min-height: 100vh;

  h5 {
    font-size: 22px;
    margin: 0;
    padding: 0;
  }

  .icon-file {
    width: 41px;
    float: left;
    margin-right: 10px;
  }

  .title-opportunity {
    text-transform: capitalize;
  }

  p {
    font-size: 14px;
    line-height: 1.42857;
    color: #888d90;
  }

  .box-test {
    border: 1px solid #d7dbdc;
    background-color: #f7f7f7;
    border-radius: 5px;
    color: #565a5c;
    padding: 20px;
    display: inline-block;

    .total {
      margin: 0;
      padding: 0 0 4px 30px;
      background-size: 20px;
      background: url("../../assets/images/ok-check.svg") no-repeat;

      span {
        font-weight: bold;
      }
    }
  }

  .btn-start {
    width: 240px;
    height: 50px;
    font-size: 14px;

    :hover {
      background-color: #376097;
    }
  }
}
</style>